import { Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const BackButton = () => {
  const navigate = useNavigate()

  const useStyles = makeStyles(() => ({
    buttonFont: {
      fontSize: '1.1em',
      fontVariant: 'all-petite-caps'
    }
  }))
  const classes = useStyles()

  const handleClick = () => {
    navigate(-1)
  }

  return (
    <>
      <Button
        className={classes.buttonFont}
        size='small'
        onClick={() => handleClick()}
      >
        <ArrowBackIosNewIcon style={{ maxHeight: '0.8em' }} />
        back
      </Button>
    </>
  )
}

export default BackButton
